import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";

const DetailRebalance = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [detail, setDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const printRef = useRef();
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchDetail = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/rebalance/${id}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) throw new Error("Gagal fetch detail rebalance");
        const result = await res.json();
        setDetail(result.data);
      } catch (err) {
        console.error(err);
        alert("Gagal mengambil data detail rebalance");
        navigate("/rebalance");
      } finally {
        setLoading(false);
      }
    };

    fetchDetail();
  }, [id, navigate]);

  const formatDate = (iso) => new Date(iso).toISOString().split("T")[0];

  const handlePrint = () => {
    const content = printRef.current.innerHTML;
    const iframe = document.createElement("iframe");

    iframe.style.position = "fixed";
    iframe.style.right = "0";
    iframe.style.bottom = "0";
    iframe.style.width = "0";
    iframe.style.height = "0";
    iframe.style.border = "0";

    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Cetak Detail</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              padding: 20px;
              color: #000;
            }

            h1, h2 {
              margin-bottom: 8px;
            }

            .message-box {
              border: 1px solid #ccc;
              background-color: #f9f9f9;
              padding: 10px;
              margin-top: 5px;
              white-space: pre-wrap;
            }

            .evidence {
              border: 1px solid #ccc;
              padding: 10px;
              margin-top: 10px;
              border-radius: 8px;
              text-align: center;
            }

            img {
              max-width: 100%;
              height: auto;
            }

            @media print {
              .label-row {
                display: flex;
                font-size: 14px;
                margin-bottom: 4px;
              }

              .label-row .label {
                width: 180px;
                font-weight: bold;
              }

              .label-row .colon {
                width: 10px;
              }

              .label-row .value {
                flex: 1;
              }
            }
          </style>
        </head>
        <body>${content}</body>
      </html>
    `);
    doc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => document.body.removeChild(iframe), 1000);
    };
  };

  if (loading) return <div className="p-6">Loading...</div>;
  if (!detail) return <div className="p-6 text-red-500">Data tidak ditemukan.</div>;

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Tombol Aksi */}
      <div className="flex justify-between items-center mb-6">
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-md shadow-sm"
        >
          Kembali
        </button>
        <button
          onClick={handlePrint}
          className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md shadow"
        >
          Cetak
        </button>
      </div>

      {/* Area yang dicetak */}
      <div ref={printRef}>
        <div className="bg-white shadow-lg rounded-xl p-8">
          {/* Header */}
          <div className="mb-6 border-b pb-4">
            <h1 className="text-xl font-bold text-gray-800 mb-1">
              Rebalance / Detail / {detail.type} /{" "}
              <span className="text-blue-600">{detail.code}</span>
            </h1>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Kolom Kiri */}
            <div className="md:col-span-2 space-y-6">
              {/* Informasi Obat */}
              <div>
                <h2 className="text-lg font-semibold text-gray-700 mb-2">Informasi Obat</h2>
                <div className="space-y-1">
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Nama</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.obat?.name || "-"}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Stock Sebelumnya</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.stock_before}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Stock Setelah</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.stock_after}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Perubahan</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.change}</div>
                  </div>
                </div>
              </div>

              {/* Detail Transaksi */}
              <div>
                <h2 className="text-lg font-semibold text-gray-700 mb-2">Detail Transaksi</h2>
                <div className="space-y-1">
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Outlet</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.outlet?.name || "-"}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Objective</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.objective}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Disetujui</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{detail.approved ? "Ya" : "Belum"}</div>
                  </div>
                  <div className="flex text-sm text-gray-700 label-row">
                    <div className="w-48 font-medium label">Tanggal</div>
                    <div className="mx-1 colon">:</div>
                    <div className="value">{formatDate(detail.created_at)}</div>
                  </div>
                </div>
              </div>

              {/* Pesan */}
              <div>
                <h2 className="text-lg font-semibold text-gray-700 mb-2">Pesan</h2>
                <div className="message-box text-sm text-gray-700">
                  {detail.message || "-"}
                </div>
              </div>
            </div>

            {/* Evidence */}
            <div className="md:col-span-1">
              <h2 className="text-lg font-semibold text-gray-700 mb-2">Evidence</h2>
              {detail.evidence ? (
                <div className="w-full border rounded-lg p-2 bg-white">
                  <img
                    src={detail.evidence}
                    alt="Evidence"
                    className="w-full h-auto object-contain rounded-md"
                  />
                </div>
              ) : (
                <div className="w-full h-64 bg-gray-100 rounded-lg flex items-center justify-center text-gray-400 border">
                  Tidak ada evidence
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailRebalance;
